import React from "react"
import FunctionalGroupListItem from "./FunctionalGroupListItem"


export default function FunctionalGroupList({ functionalGroups, getFunctionalGroups }) {
  return (
    <div id="TrainingList">
      { functionalGroups.length ?
        <table className="qms-training-table">
          <thead>
            <tr className="qms-training-table-head">
              <th>Functional Group Name</th>
            </tr>
          </thead>
          <tbody>
            { functionalGroups.map(functionalGroup => {
              return (
                <FunctionalGroupListItem
                  key={ functionalGroup.id }
                  functionalGroup={ functionalGroup }
                  getFunctionalGroups={ getFunctionalGroups }
                />
              )
            }) }
          </tbody>
        </table>
        :
        <h5>There are no functional groups that match the search term.</h5>
      }
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/FunctionalGroupContainer/FunctionalGroupList.js